import EmailService from 'web-core/src/email-service';

export const EMAIL_SUBSCRIBE_SENT = 'EMAIL_SUBSCRIBE_SENT';
export const EMAIL_SUBSCRIBE_RECEIVED = 'EMAIL_SUBSCRIBE_RECEIVED';

const emailSubscribeSent = () => ({
  type: EMAIL_SUBSCRIBE_SENT,
});

const emailSubscribeReceived = ({ email, lists }) => ({
  type: EMAIL_SUBSCRIBE_RECEIVED,
  email,
  lists,
});

export const postEmailSubscription = ({ params, options }) => (
  dispatch,
  getState,
  { apiClient },
) => {
  const svc = new EmailService({ client: apiClient });
  dispatch(emailSubscribeSent());
  return svc.subscribe(params, options).then((res) => {
    dispatch(emailSubscribeReceived(params));
    return res;
  });
};
